import {INIT_URL, SIGNOUT_USER_SUCCESS, USER_DATA, USER_TOKEN_SET} from "../../constants/ActionTypes";

// Helper function to safely parse JSON from localStorage
const getLocalStorageItem = (key, isJson = false) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    if (isJson) {
      return JSON.parse(item);
    }
    return item;
  } catch (e) {
    console.error(`Error parsing localStorage item '${key}':`, e);
    return null;
  }
};

const INIT_STATE = {
  token: getLocalStorageItem('token', false), // Token is a JWT string, not JSON
  initURL: '',
  authUser: getLocalStorageItem('user', true), // User data might be JSON
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ''
      }
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    default:
      return state;
  }
}
